<template>
    <Dialog
        v-model:visible="dialogVisible"
        :style="{width: '450px'}"
        header="Peringatan"
        :modal="true"
        :closable="false"
    >
        <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle p-mr-2" style="font-size: 2rem"></i>
            <span class="ml-2">
                {{ message }}
            </span>
        </div>
        <template #footer>
            <Button
                label="Tidak"
                icon="pi pi-times"
                class="p-button-raised p-button-danger"
                @click="onClose"
            />
            <Button
                label="Ya"
                icon="pi pi-check"
                class="p-button-raised p-button-primary"
                :loading="loading"
                @click="onSubmit"
            />
        </template>
    </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import Button from "primevue/button";

export default {
    name: "DeleteDialog",
    components: {
        Dialog,
        Button
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false
        },
        message: {
            type: String,
            default: 'Apakah anda yakin akan menghapus ?'
        }
    },
    emits: ['update:visible', 'delete'],
    data() {
        return {
            dialogVisible: this.visible,
        };
    },
    updated() {
        if (this.visible) {
            this.dialogVisible = this.visible;
        }
    },
    methods: {
        onSubmit() {
            this.$emit('delete', true);
        },
        onClose() {
            this.$emit('update:visible', false);
            this.dialogVisible = false;
        }
    }
}
</script>

<style scoped>

</style>
